var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCourseintro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 593,
    height: 731,
    viewBox: "0 0 593 731",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M318.724 361.11c12.33 15.413 26.023 32.332 35.629 44.162 10.681-32.118-3.585-76.997-19.499-110.549-3.871 20.863-9.176 42.944-16.13 66.387zM243.594 242.245c-15.842 15.199-30.037 43.588-19.355 87.965 9.606-.788 23.227-1.864 35.557-3.011-7.025-31.544-12.33-59.719-16.202-84.954z",
    fill: "#FF062E",
    fillOpacity: 0.56
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M277.646 400.325c-88.535-340.247-15.7-369.139 11.828-380.753 27.528 43.445 100.363 156.431 11.685 394.303l-23.513-13.55z",
    fill: "url(#5tgyj95yoa)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M303.74 380.753C215.135 40.577 287.969 11.686 315.569 0c27.528 43.445 100.363 156.431 11.685 394.303l-23.514-13.55z",
    fill: "url(#pc07chlusb)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M301.159 413.875c88.678-237.872 15.843-350.858-11.685-394.303v387.564l11.685 6.739z",
    fill: "url(#fbwd43xzgc)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M315.928 139.368c0 20.719-12.187 30.469-27.242 21.794-15.054-8.674-27.241-32.548-27.241-53.266 0-20.72 12.187-30.47 27.241-21.795 15.055 8.675 27.242 32.548 27.242 53.267z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M289.26 647.015c14.767 32.476 36.775 60.436 61.364 74.631 44.447 25.665 80.505-3.298 80.577-64.666 0-61.368-36.059-131.984-80.505-157.649-14.624-8.46-28.317-10.969-40.145-8.388-6.237-10.18-9.248-23.085-11.9-34.412-3.083-13.048-5.664-24.16-12.115-26.956-7.384-3.226-10.682 4.947-15.342 16.274-2.724 6.667-5.95 14.553-10.681 21.794-5.09-5.377-10.466-9.822-16.13-13.048-23.728-13.693-43.514-1.864-48.174 26.383-3.226-2.438-6.452-4.66-9.749-6.596-38.067-21.938-68.892 2.939-68.892 55.704 0 52.693 30.825 113.201 68.82 135.138 36.919 21.293 67.1-1.577 68.82-51.115 6.954 12.904 16.201 23.729 26.453 29.608a38.75 38.75 0 0 0 7.599 3.298z",
    fill: "url(#2p3zi9jkvd)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "m382.095 256.154 194.13 112.053.072 101.157-176.925-102.16-17.134 5.591-.143-116.641z",
    fill: "url(#vuiblufw0e)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M519.735 385.987v-27.458L593 400.827v27.457l-73.265-42.297z",
    fill: "#FF062E",
    fillOpacity: 0.56
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "m432.062 309.563 42.51 24.591v8.889l-42.51-24.518v-8.962zM432.061 327.343l76.778 44.305v8.89l-76.778-44.305v-8.89z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m432.061 345.122 99.288 57.353v8.89l-99.288-57.353v-8.89z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M421.595 312.79c0 8.316-4.947 12.259-11.04 8.746-6.094-3.513-11.04-13.119-11.04-21.436 0-8.316 4.946-12.259 11.04-8.746 6.093 3.513 11.04 13.12 11.04 21.436z",
    fill: "#FF062E",
    fillOpacity: 0.56
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M214.705 113.273 20.646 1.291l.072 101.156 176.925 102.089 17.133 25.379-.071-116.642z",
    fill: "url(#qb2r85ue4f)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 40.72V13.264L73.265 55.56v27.458L0 40.72z",
    fill: "#FF062E",
    fillOpacity: 0.71
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m164.81 109.114-42.511-24.518v8.89l42.511 24.518v-8.89zM164.881 126.894 82.942 79.577v8.89l81.939 47.316v-8.889zM164.881 144.673 65.594 87.32v8.89l99.287 57.353v-8.89z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M175.348 124.385c0 8.316 4.946 17.922 11.04 21.435 6.093 3.513 11.04-.43 11.04-8.746s-4.947-17.923-11.04-21.436c-6.165-3.441-11.112.43-11.04 8.747z",
    fill: "#FF062E",
    fillOpacity: 0.56
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M188.897 221.24 72.978 154.352v60.364l115.919 66.888V221.24z",
    fill: "url(#m41xd86ong)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m102.657 185.967 39.715 22.942v7.24l-39.715-22.941v-7.241zM102.729 200.521l74.268 42.871v7.313l-74.268-42.871v-7.313z",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M96.564 188.118c0 4.947-2.94 7.313-6.596 5.234-3.656-2.079-6.595-7.815-6.595-12.833 0-4.947 2.94-7.313 6.595-5.234 3.656 2.151 6.596 7.886 6.596 12.833z",
    fill: "#FF062E",
    fillOpacity: 0.56
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m533.213 266.835-115.919-66.888v60.364l115.919 66.96v-60.436z",
    fill: "url(#lfsnaym5xh)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "m446.973 231.635 39.715 22.941v7.241l-39.715-22.941v-7.241zM446.973 246.188l74.268 42.872v7.312l-74.268-42.871v-7.313z",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M440.879 233.786c0 4.947-2.939 7.312-6.595 5.233-3.656-2.079-6.596-7.814-6.596-12.832 0-4.947 2.94-7.313 6.596-5.234 3.656 2.079 6.595 7.886 6.595 12.833z",
    fill: "#FF062E",
    fillOpacity: 0.56
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "5tgyj95yoa",
    x1: 392.797,
    y1: 31.635,
    x2: 169.938,
    y2: 417.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pc07chlusb",
    x1: 418.885,
    y1: 12.069,
    x2: 196.026,
    y2: 398.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fbwd43xzgc",
    x1: 351.241,
    y1: 115.826,
    x2: 179.203,
    y2: 426.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2p3zi9jkvd",
    x1: 335.058,
    y1: 490.31,
    x2: 238.801,
    y2: 657.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "vuiblufw0e",
    x1: 465.5,
    y1: 259.429,
    x2: 490.594,
    y2: 462.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qb2r85ue4f",
    x1: 172.409,
    y1: 72.767,
    x2: 72.199,
    y2: 151.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m41xd86ong",
    x1: 144.023,
    y1: 195.307,
    x2: 117.88,
    y2: 240.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lfsnaym5xh",
    x1: 488.312,
    y1: 240.957,
    x2: 462.168,
    y2: 286.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseintro);
export default __webpack_public_path__ + "static/media/Course intro.fb76243f1571c4ef419f1a2b87150488.svg";
export { ForwardRef as ReactComponent };